export default __webpack_public_path__ + "static/background-noise-23b748d4d918dab1f23e7837963a1ea0.png";